import { Icon } from './Icon'

const ITENS = [
  { icone: 'eye', titulo: 'Mais visibilidade', sub: 'para o seu restaurante' },
  { icone: 'users', titulo: 'Mais pedidos', sub: 'e clientes recorrentes' },
  { icone: 'grid', titulo: 'Operação', sub: 'mais organizada' },
  { icone: 'clock', titulo: 'Mais tempo', sub: 'para o que realmente importa' },
]

export function Value() {
  return (
    <section className="value">
      <div className="shell value__inner">
        <div className="value__head">
          <h2 className="h2" data-reveal="mask">É vender <span className="accent">melhor.</span></h2>
          <p data-reveal="up" data-delay="90">
            Mais do que estar nos aplicativos, é ter uma operação preparada para crescer.
          </p>
        </div>
        <ul className="value__grid">
          {ITENS.map((item, i) => (
            <li key={item.titulo} data-reveal="up" data-delay={i ? String(i * 80) : undefined}>
              <span className="value__ico"><Icon name={item.icone} /></span>
              <b>{item.titulo}</b><small>{item.sub}</small>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
